import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg width="50" height="53" viewBox="14 10 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1837_4083)">
        <ellipse cx="24.9985" cy="19.8411" rx="1.74194" ry="1.74194" fill="#F59C53" />
        <path
          d="M24.7327 10.6475C29.663 10.6476 33.6594 14.6448 33.6594 19.5752C33.6593 24.5054 29.6629 28.5018 24.7327 28.502C19.8023 28.502 15.8051 24.5055 15.8049 19.5752C15.8049 14.6447 19.8022 10.6475 24.7327 10.6475Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <ellipse cx="24.9985" cy="24.4861" rx="1.74194" ry="1.74194" fill="#F59C53" />
        <path
          d="M24.7327 15.2925C29.663 15.2927 33.6594 19.2898 33.6594 24.2202C33.6593 29.1504 29.6629 33.1468 24.7327 33.147C19.8023 33.147 15.8051 29.1505 15.8049 24.2202C15.8049 19.2897 19.8022 15.2925 24.7327 15.2925Z"
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1837_4083"
          x="-52.1051"
          y="-55.0851"
          width="153.965"
          height="153.965"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.25073" />
          <feGaussianBlur stdDeviation="6.25073" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.960784 0 0 0 0 0.611373 0 0 0 0 0.32549 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1837_4083" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1837_4083" result="shape" />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width="50" height="53" viewBox="14 10 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1837_3972)">
        <ellipse cx="24.9988" cy="20.1267" rx="1.74194" ry="1.74194" fill="#888888" />
        <path
          d="M24.7334 10.9336C29.6637 10.9338 33.6602 14.931 33.6602 19.8613C33.66 24.7916 29.6636 28.7879 24.7334 28.7881C19.803 28.7881 15.8058 24.7917 15.8057 19.8613C15.8057 14.9309 19.8029 10.9336 24.7334 10.9336Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <ellipse cx="24.9988" cy="24.7712" rx="1.74194" ry="1.74194" fill="#888888" />
        <path
          d="M24.7334 15.5781C29.6637 15.5783 33.6602 19.5755 33.6602 24.5059C33.66 29.4361 29.6636 33.4324 24.7334 33.4326C19.803 33.4326 15.8058 29.4362 15.8057 24.5059C15.8057 19.5754 19.8029 15.5781 24.7334 15.5781Z"
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1837_3972"
          x="-52.1051"
          y="-54.7994"
          width="153.965"
          height="153.965"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.25073" />
          <feGaussianBlur stdDeviation="6.25073" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1837_3972" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1837_3972" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default Icon;
